module.exports = __webpack_public_path__ + "static/media/pago2.686f8881.svg";